import { POST, GET } from '@/utils/request'
import Api from './url'

export interface ChatParams {
  token?: string
  query: string
  conversationId?: string
}

export const queryArticlesByPlatformId = async (params: any = {}) => {
  return await GET({
    url: Api.queryArticlesByPlatformId,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo'
    }
  })
}

export const conversationFeedback = async (data: { conversationId: string; feedbackTag: string }) => {
  return await POST({ url: Api.conversation, data, showError: false })
}

export const endConversation = async (data: { conversationId: string }) => {
  return await POST({ url: Api.end, data, showError: false })
}
export const getGroupId = async (params: any = {}) => {
  return await GET({ url: Api.getGroupId, params, showError: false, showHttpError: false, showStatusError: false })
}
export const toAiChat = async (data: any = {}) => {
  return await POST({ url: Api.aiChat, data, showError: false, showHttpError: false, showStatusError: false })
}
// 创建工单时机
export const toCondition = async (params: any = {}) => {
  return await GET({ url: Api.toCondition, params, showError: false, showHttpError: false, showStatusError: false })
}

export const citySwitch = async (params: object) => {
  return await GET({
    url: Api.citySwitch,
    params,
    showError: false
  })
}

export const getHotLine = async () => {
  return await GET({ url: Api.getHotLine, showError: false })
}

export const getWelcomeMessages = async (data: any = {}) => {
  return await POST({ url: Api.welcome, data, showError: false, showHttpError: false, showStatusError: false })
  // return await new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve({
  //       data: {
  //         welcome: '您好师傅，我是智能客服小闪，有问题找小闪，请用一句话描述您的问题',
  //         problem: '师傅,看到您已进入就位圈，是遇到无法拿到收件码的问题吗？请选择问题或描述您的问题：',
  //         aiFlag: true, // 是否匹配到AI场景
  //         more: true, // 是否展示更多
  //         // 展示的卡片
  //         problems: [{
  //           problem: '已拿到物品无法获取收件码已拿到物品无法获取收件码'
  //         }, {
  //           problem: '联系不到寄件人'
  //         }]
  //       }
  //       //   [
  //       //   {
  //       //     id: 'welcome-1',
  //       //     type: 'text',
  //       //     content: 'Hi，我是您的专属闪送智能助手~',
  //       //     sender: 'agent',
  //       //     timestamp: Date.now()
  //       //   },
  //       //   {
  //       //     id: 'welcome-2',
  //       //     type: 'text',
  //       //     content: '请问您是遇到了什么问题呢？',
  //       //     options: ['无法接单', '提现相关', '申诉相关', '其他问题'],
  //       //     sender: 'agent',
  //       //     timestamp: Date.now()
  //       //   },
  //       //   {
  //       //     id: 'welcome-3',
  //       //     type: 'action_card',
  //       //     content: '遇到问题了？',
  //       //     actions: [
  //       //       { text: '马上升级', actionType: 'upgrade' },
  //       //       { text: '联系用户', actionType: 'contact_user' }
  //       //     ],
  //       //     sender: 'agent',
  //       //     timestamp: Date.now()
  //       //   }
  //       // ]
  //     })
  //   }, 500)
  // })
}
